import type { Question } from '@mentimeter/legacy-series-types/question';
import type { Slide as VotingSlide } from '../../compatibility-overrides/voting-types';
import type { CompatibilitySlide } from '../../compatibility-types';
import type { CommonQuestionProperty } from './get-common-question-property';

export const getQuestionParagraphProperty = (
  target: CompatibilitySlide<'paragraph'> | VotingSlide<'paragraph'>,
  prop: keyof Question,
) => {
  const staticContents = target.staticContent;

  switch (prop as keyof Omit<Question, CommonQuestionProperty>) {
    case 'question':
      return staticContents.heading;
    case 'question_description':
      return staticContents.paragraph;
    default:
      return undefined;
  }
};
